import PageHeader from 'src/components/page-header/page-header';

export default function ShipmentsHeader() {
  return <PageHeader title="Cargas" />;
}